export const radioFields = [
    {
        id: 1,
        value: "PUBLIC",
        label: "Public",
        showInfo: false,
    },
    {
        id: 2,
        value: "PRIVATE",
        label: "Private",
        showInfo: true,
        infoMessage: "Private Accounts do not come up in Search but can be accessed via URL"
    },
    {
        id: 1,
        value: "HIDDEN",
        label: "Hidden",
        showInfo: true,
        infoMessage: "Hidden accounts do not come up in Search and CANNOT be accessed via URL"
    }
]